const API_URL = `${process.env.REACT_APP_API_URL}/google-click-id`;

// Google Ads click params captured from the landing URL (sessionStorage: same tab only).
const SESSION_KEY = 'dastaan__google_click';
const DEVICE_KEY = 'dastaan__device_id';

const getDeviceId = () => {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = window.crypto?.randomUUID?.() ||
        `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch (e) {
    return '';
  }
};

const loadClick = () => {
  try {
    return JSON.parse(sessionStorage.getItem(SESSION_KEY));
  } catch (e) {
    return null;
  }
};

const saveClick = (click) => {
  try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(click)); } catch (e) {}
};

const send = (click, event, phone = '') => {
  fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      device_id: getDeviceId(),
      phone,
      gclid: click.gclid,
      gbraid: click.gbraid,
      wbraid: click.wbraid,
      utm_source: click.utm_source,
      utm_medium: click.utm_medium,
      utm_campaign: click.utm_campaign,
      event,
    }),
  }).catch(() => {});
};

// On landing: if the URL carries a Google click id, store it and report the visit
// once per click (a refresh with the same gclid does not report again).
export const captureGoogleClick = () => {
  const params = new URLSearchParams(window.location.search);
  const click = {
    gclid: params.get('gclid') || '',
    gbraid: params.get('gbraid') || '',
    wbraid: params.get('wbraid') || '',
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
  };
  if (!click.gclid && !click.gbraid && !click.wbraid) return;

  const saved = loadClick();
  if (saved?.gclid === click.gclid && saved?.gbraid === click.gbraid && saved?.wbraid === click.wbraid) return;

  saveClick(click);
  send(click, 'landing');
};

// After the user enters their number: report again with the phone attached.
export const reportGoogleClickPhone = (phone) => {
  const click = loadClick();
  if (!click) return;
  send(click, 'phone_submit', phone);
};
